import { render, staticRenderFns } from "./horizonLayout.vue?vue&type=template&id=0c83dddc"
import script from "./horizonLayout.vue?vue&type=script&lang=js"
export * from "./horizonLayout.vue?vue&type=script&lang=js"
import style0 from "./horizonLayout.vue?vue&type=style&index=0&id=0c83dddc&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c83dddc')) {
      api.createRecord('0c83dddc', component.options)
    } else {
      api.reload('0c83dddc', component.options)
    }
    module.hot.accept("./horizonLayout.vue?vue&type=template&id=0c83dddc", function () {
      api.rerender('0c83dddc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Layout/Wrappers/horizonLayout.vue"
export default component.exports